import { actions as authActions } from '@saucelabs/sl-container-authentication';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';

export const updateSetting = (payload) => (dispatch) => (
  dispatch(actions.updateSetting(payload)).then(
    () => {
      const data = Object.entries(payload)
        .filter(([key]) => key !== 'username')
        .reduce((acc, [name, value]) => ({ ...acc, ...{ name, value } }), {});

      dispatch(authActions.updateSetting(data));
      dispatch(notificationActions.notifySuccess('Settings has been updated'));
    },
    () => {
      dispatch(notificationActions.notifyError('There was a problem with updating settings'));
    },
  )
);

export const resetAccessKeys = () => (dispatch) => (
  dispatch(actions.resetAccessKeys()).then(
    () => dispatch(notificationActions.notifySuccess('Access keys cleared!')),
    () => dispatch(notificationActions.notifyError('There was a problem with reseting keys')),
  )
);

export const updateSamlSettings = ({ username, settings }) => (dispatch) => (
  dispatch(actions.updateSamlSettings({ username, payload: settings })).then(
    () => dispatch(notificationActions.notifySuccess('Settings has been updated!')),
    (error) => dispatch(notificationActions.notifyError(error.response.data.error)),
  )
);

export const updateSamlMetadata = ({ username, settings }) => (dispatch) => (
  dispatch(actions.updateSamlSettings({ username, payload: settings })).then(
    () => dispatch(notificationActions.notifySuccess('Metadata has been updated!')),
  )
);

export const getOrganization = (payload) => (dispatch) => (
  dispatch(actions.getOrganization(payload))
);

export const patchUSSetting = (payload) => (dispatch, getState) => {
  const organizationId = getState().user.get('organization').id;

  return dispatch(actions.patchUSSettings({ organizationId, ...payload }))
    .then(() => dispatch(notificationActions.notifySuccess('Setting has been updated')))
    .catch(() => {
      dispatch(notificationActions.notifyError('There was a problem with updating settings'));
    });
};

export const updateUIS = (payload) => (dispatch, getState) => {
  const organizationId = getState().user.get('organization').id;

  return dispatch(actions.patchUSSettings({ organizationId, ...payload }))
    .then(() => dispatch(notificationActions.notifySuccess('Unique identifier string has been updated')))
    .catch((error) => {
      dispatch(notificationActions.notifyError('There was a problem with updating settings'));
      throw error;
    });
};

export const deleteSamlMetadata = ({ username }) => (dispatch) => (
  dispatch(actions.deleteSamlFile({ username }))
    .then(() => {
      dispatch(notificationActions.notifySuccess('Metadata file has been removed'));
    })
    .catch((error) => {
      dispatch(notificationActions.notifyError('There was a problem with metadata file removal'));
      throw error;
    })
);
